module.exports = __webpack_public_path__ + "img/arrows-crossed.e88b6161.svg";